// Server-side rendering (Pennylane transmission): headless Chromium reads the PDF from the DOM
export const serverRenderParams = () => {
    const params = new URLSearchParams(window.location.search)
    if(!params.get('pdf_render_signature')) return null
    return {pdf_render_expires: params.get('pdf_render_expires'), pdf_render_signature: params.get('pdf_render_signature')}
}

const exposeToServerRender = (id, type, content) => {
    if(document.getElementById(id)) return
    const el = document.createElement('script')
    el.id = id
    el.type = type
    el.textContent = content
    document.body.appendChild(el)
}

export const exposeServerRenderError = (message) => {
    if(serverRenderParams()) exposeToServerRender('freebird-pdf-error', 'application/json', JSON.stringify({message:String(message)}))
}

// A rendering crash must end the server render at once instead of waiting for its timeout
if(typeof window !== 'undefined' && serverRenderParams()){
    window.addEventListener('error', (event) => exposeServerRenderError(event.message))
    window.addEventListener('unhandledrejection', (event) => exposeServerRenderError(event.reason))
}

export const exposePdfToServerRender = (blob) => {
    if(!serverRenderParams() || !blob) return
    const reader = new FileReader();
    reader.onloadend = () => exposeToServerRender('freebird-pdf', 'application/pdf-base64', reader.result.replace('data:application/pdf;base64,',''));
    reader.readAsDataURL(blob);
}
